import React from 'react';
import { AriaOverlayProps, DismissButton } from 'react-aria';
import { PopoverOverlay } from 'components/Popover';

export interface PopoverProps
  extends Pick<AriaOverlayProps, 'isOpen' | 'onClose'> {
  children?: React.ReactNode;
}

// TODO share with Dialog?
/**
 * Renders an overlay that holds the popup menu UI.
 */
export const Popover = React.forwardRef<HTMLDivElement, PopoverProps>(
  ({ children, isOpen, onClose, ...props }, ref) => {
    return (
      // NB: PopoverOverlay from components/Popover is used here becuase ultimately
      // the Popover used in the Menu component should be replaced by
      // components/Popover
      <PopoverOverlay isOpen={isOpen} onClose={onClose} ref={ref} {...props}>
        {children}
        <DismissButton onDismiss={onClose} />
      </PopoverOverlay>
    );
  },
);

export default Popover;
